<template>
    <div>
        <img :id="'barcode-' + data" />
        <p class="text">{{ text }}</p>
        <p class="text">{{ sourceText() }}</p>
        <div class="vertical">
            <p class="location">{{ location ? location.toUpperCase() : '' }}</p>
            <p class="type">{{ type }}</p>
        </div>
    </div>
</template>

<script>
    import jsbarcode from "jsbarcode";

    export default {
        name: "Barcode",
        props: [ 'data', 'text', 'location', 'type', 'source' ],
        mounted() {
            jsbarcode('#barcode-' + this.data, this.data, {
                height: 28,
                width: 2,
                margin: 0,
                displayValue: false,
            });
        },
        methods: {
            sourceText() {
                if (this.source && this.source.length && this.type === 'active') {
                    return '*';
                } else if (this.source && this.source.length) {
                    return this.source;
                }

                return '';
            }
        }
    }
</script>

<style scoped>

</style>